import * as User from '../../user'
import * as Menu from '../constants'
import * as Types from './types'
export * from '../constants'

export const TOGGLE_SUBNAV_MOBILE = 'TOGGLE_SUBNAV_MOBILE'
export const TOGGLE_MAIN_MENU_MOBILE = 'TOGGLE_MAIN_MENU_MOBILE'
export const SELECT_NAV_MENU = 'SELECT_NAV_MENU'

export const ACTIVE_MENU_ITEM = 'ACTIVE_MENU_ITEM'

export const ContentItems: Types.NavItem[] = [
  {
    href: Menu.CONTENT_POSTS_URL,
    label: Menu.CONTENT_POSTS_LABEL,
  },
  {
    href: Menu.CONTENT_SOURCES_URL,
    label: Menu.CONTENT_SOURCES_LABEL,
  },
  {
    href: Menu.CONTENT_LEAD_POSTS_URL,
    label: Menu.CONTENT_LEAD_POSTS_LABEL,
  },
  {
    href: Menu.CONTENT_LEAD_TEXT_URL,
    label: Menu.CONTENT_LEAD_TEXT_LABEL,
  },
  {
    href: Menu.CONTENT_PROMOTIONS_URL,
    label: Menu.CONTENT_PROMOTIONS_LABEL,
  },
  {
    href: Menu.CONTENT_CALENDAR_URL,
    label: Menu.CONTENT_CALENDAR_LABEL,
  },
  {
    href: Menu.CONTENT_TRAINING_URL,
    label: Menu.CONTENT_TRAINING_LABEL,
    roleNames: [User.BETA_ROLE],
  },
]

const SettingsItems: Types.NavItem[] = [
  {
    href: Menu.NEWSLETTER_SETTINGS_URL,
    label: Menu.NEWSLETTER_SETTINGS_LABEL,
  },
  {
    href: Menu.NEWSLETTER_SCHEDULES_URL,
    label: Menu.NEWSLETTER_SCHEDULES_LABEL,
  },
  {
    href: Menu.NEWSLETTER_CAMPAIGNS_URL,
    label: Menu.NEWSLETTER_CAMPAIGNS_LABEL,
  },
]

export const AnalyticsItems: Types.NavItem[] = [
  {
    href: Menu.REPORTS_TOPICS_URL,
    label: Menu.REPORTS_TOPICS_LABEL,
  },
  {
    href: Menu.REPORTS_SOURCES_URL,
    label: Menu.REPORTS_SOURCES_LABEL,
  },
  {
    href: Menu.REPORTS_ARTICLES_URL,
    label: Menu.REPORTS_ARTICLES_LABEL,
  },
  {
    href: Menu.REPORTS_ANALYTICS_URL,
    label: Menu.REPORTS_ANALYTICS_LABEL,
  },
  {
    href: Menu.REPORTS_OTHER_CLICKS_URL,
    label: Menu.REPORTS_OTHER_CLICKS_LABEL,
  },
  {
    href: Menu.REPORTS_DAILY_URL,
    label: Menu.REPORTS_DAILY_LABEL,
  },
  {
    href: Menu.REPORTS_KNOWLEDGETIERS_URL,
    label: Menu.REPORTS_KNOWLEDGETIERS_LABEL,
  },
  {
    href: Menu.REPORTS_ADVERTISING_URL,
    label: Menu.REPORTS_ADVERTISING_LABEL,
  },
]

export const navItems: Types.NavItem[] = [
  {
    children: AnalyticsItems,
    href: Menu.REPORTS_URL_HOME,
    isNoLink: true,
    isOpen: false,
    label: Menu.REPORTS_LABEL,
    roleNames: [User.REPORTS_ROLE, User.ADMIN_ROLE],
  },
  {
    children: ContentItems,
    href: Menu.CONTENT_URL_HOME,
    isNoLink: true,
    isOpen: false,
    label: Menu.CONTENT_LABEL,
    roleNames: [User.CONTENT_ROLE, User.ADMIN_ROLE],
  },
  {
    href: Menu.SUBSCRIBERS_URL_HOME,
    isOpen: false,
    label: Menu.SUBSCRIBERS_LABEL,
    roleNames: [User.MEMBER_ROLE, User.ADMIN_ROLE],
  },
  {
    children: SettingsItems,
    href: Menu.NEWSLETTER_URL_HOME,
    isNoLink: true,
    isOpen: false,
    label: Menu.NEWSLETTER_LABEL,
    roleNames: [User.CONTENT_ROLE, User.ADMIN_ROLE],
  },
]



// WEBPACK FOOTER //
// ./src/components/menu/left-nav/constants.ts